import { Type } from '@angular/core';
import { MatSort } from '@angular/material/sort';

import { IColumn } from '../../interfaces/column.table';
import { RenderData } from '../../interfaces/render-data';
import { BoolItemRendererComponent } from '../../item-renderer/item-renderers/item-renderers.module';

export class BoolColumn<T> implements IColumn<T> {
  header: string;
  sortField: string;
  renderer: Type<any>;
  renderData: RenderData;
  sortFunction?: (data: T[], sort: MatSort) => T[];

  constructor(
    header: string,
    value: (item: T) => boolean,
    sortField?: string,
    renderData?: RenderData,
    sortFunc?: (data: T[], sort: MatSort) => T[]
  ) {
    this.header = header;
    this.sortField = sortField;
    this.value = value;
    this.renderer = BoolItemRendererComponent;

    if (renderData && renderData.width) {
      this.renderData = renderData;
    } else {
      this.renderData = new RenderData();
    }

    this.sortFunction = sortFunc;
  }

  value(item: any): any {}
}
